export default function limitNumberWithinRange(v, min, max) {
  return Math.min(Math.max(parseInt(v), min), max)
}